/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DescribeResponse
 */
export interface DescribeResponse {
    /**
     * 
     * @type {string}
     * @memberof DescribeResponse
     */
    message: string;
}

/**
 * Check if a given object implements the DescribeResponse interface.
 */
export function instanceOfDescribeResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function DescribeResponseFromJSON(json: any): DescribeResponse {
    return DescribeResponseFromJSONTyped(json, false);
}

export function DescribeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescribeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function DescribeResponseToJSON(value?: DescribeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

